import { commonViewTexts } from '../common';

export const editDialogCommonViewTexts = {
  cancel: commonViewTexts.backToListPage,
  ok: commonViewTexts.save,
  description1: (title: string) => `${title}情報を編集します。`,
  description2: `下記入力エリアに情報を入力し「${commonViewTexts.save}」ボタンを押してください。`
};
